import { type Credential, type StreamDescriptor } from '../types';
import { getDeviceId } from './deviceId';

export interface LicenseHeaderOptions {
  /** Override the persistent device id (defaults to getDeviceId()). */
  deviceId?: string;
  /** Optional viewer id, forwarded as X-User-Id for billing/tracking. */
  userId?: string;
}

/**
 * Headers a host player must attach to the DRM license POST. The license URL
 * itself must be sent VERBATIM (its signed query string is the token) — these
 * headers are the rest of the contract:
 *   - x-api-key   : the SAME key used to resolve playback (cid binding)
 *   - X-Device-Id : required, persistent
 *   - X-Match-Urn : advisory (the signed `m` param is authoritative)
 *   - X-User-Id   : optional
 * Body must be the raw EME challenge bytes (application/octet-stream).
 */
export function licenseRequestHeaders(
  descriptor: StreamDescriptor,
  credential: Credential,
  opts: LicenseHeaderOptions = {},
): Record<string, string> {
  const headers: Record<string, string> = {
    'x-api-key': credential.apiKey,
    'X-Match-Urn': descriptor.matchUrn,
    'X-Device-Id': opts.deviceId ?? getDeviceId(),
    'Content-Type': 'application/octet-stream',
  };
  if (opts.userId) headers['X-User-Id'] = opts.userId;
  return headers;
}
